import {SUCCESS} from "../../../../../constants/action-postfix";
import {DISEASED_PERIOD_REQUEST} from "../diseasedPeriodReducer";


const initialState = [];

export const diseasedPeriodListReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${DISEASED_PERIOD_REQUEST}${SUCCESS}`:
            return action.payload;

        default:
            return state;
    }
};